import { message } from "antd";
import { createContext, useContext, useState } from "react";
import Loader from "../utils/Loader.jsx";
const GlobalUIContext = createContext(null);

export const useGlobalUI = () => useContext(GlobalUIContext);

export const GlobalUIProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <GlobalUIContext.Provider
      value={{
        message: messageApi,
        showLoader,
        hideLoader,
      }}
    >
      {contextHolder}

      {loading && <Loader />}

      {children}
    </GlobalUIContext.Provider>
  );
};
